import React, { Component } from 'react';
import Router from 'next/router';
import { connect } from 'react-redux';
import { getLinkProps } from 'util/link';
import { findClosestNode } from 'util/dom';
import { GEN_ROLLOUT_COOKIE_NAME } from 'constants/gen';
import { formatWrappedComponentDisplayName } from 'util/hoc';

export default WrappedComponent => {
  // eslint-disable-next-line react/prefer-stateless-function
  class WithAutoLink extends Component {
    static displayName = formatWrappedComponentDisplayName(
      'WithAutoLink',
      WrappedComponent
    );

    static handleClick(e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) {
        // Ignore click for new tab or window
        return;
      }
      // Get the closest anchor element
      const node = findClosestNode(e.target, 'a');
      if (node) {
        // Use getAttribute instead of href so it gets the href value without
        // appending the full path to relative URLs
        const props = getLinkProps(node.getAttribute('href'));
        // Check if the parsed href is different to the original href. If it is,
        // the link is handled and can be client side routed
        if (props && props.as) {
          // This is a handled link, use the client side router...
          // Note: this replicates some of the logic in next/link, e.g. scrolling
          // to the top after routing
          e.preventDefault();
          Router.push(props.href, props.as)
            .then(success => {
              if (success) {
                // Scroll to top...
                window.scrollTo(0, 0);
                document.body.focus();
              }
            })
            .catch(() => {
              // An error has occured when attempting to client side route, e.g.
              // the URL might be malformed, e.g. https://<domain>//<path>
              // Navigate so _something_ happens
              window.location.href = node.href;
            });
        }
      }
    }
    render() {
      /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, react/prop-types */
      if (this.props.flips.includes(GEN_ROLLOUT_COOKIE_NAME)) {
        // If the partial rollout cookie is set disable client side routing
        return <WrappedComponent {...this.props} />;
      }
      return (
        <div onClick={WithAutoLink.handleClick}>
          <WrappedComponent {...this.props} />
        </div>
      );
    }
  }
  return connect(({ app }) => ({
    flips: app.flips
  }))(WithAutoLink);
};
